import React, { Component } from "react";
import TopBarNav from '../components/topbar';
import Navigation from '../components/navigation';
import ViewToMovedToLOSCases from '../components/tomovetolos'
class ToBeMoveToLOS extends Component {
    render() {
        return (
          <>
          <div className='NewCasesWrap'>
             <TopBarNav/>
              <Navigation/>
              <ViewToMovedToLOSCases />
          </div>
          
          </>
        )
    }
}
export default ToBeMoveToLOS;